import { Box, Container, Flex, Grid, Heading, Skeleton, useMediaQuery } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import Footer from '../../Footer';
import { useMeQuery, useToggleWelcomeMsgMutation } from '../../generated/graphql';
import NavBar from '../NavBar';
import CareerAssessment from './CareerAssessment';
import Checklist from './Checklist';
import './Dashboard.css';
import DiscordInvite from './DiscordInvite';
import HiringGuide from './HiringGuide';
import ProfileLive from './ProfileLive';
import WelcomeCard from './WelcomeCard';

export interface User {
    name: string;
}

export interface IChecklistItem {
    text: string;
    completed: boolean;
    hasLoaded: boolean;
    hide: boolean;
}

function Dashboard() {
    const { loading, data: userData } = useMeQuery();
    const [isMobile] = useMediaQuery('(max-width: 400px)');
    const [shouldShowWelcomeMsg, setShouldShowWelcomeMsg] = useState(false);
    const [toggleWelcomeMsgMutation] = useToggleWelcomeMsgMutation({
        variables: {
            userId: userData?.me?.profile?.user_id ?? ''
        }
    });
    useEffect(() => {
        setShouldShowWelcomeMsg(userData?.me?.showWelcomeMsg ?? false);
    }, [loading, setShouldShowWelcomeMsg, userData?.me?.showWelcomeMsg]);

    if (loading) return null;

    return (
        <>
            <NavBar />
            <Container maxW="container.xl" pt="2" pr="0" pl="0" my="4">
                <Grid templateColumns={{ base: '1fr', lg: '59% 2fr' }} gap={6} alignItems={'start'}>
                    <Flex flexDirection="column" margin={{ base: '1rem', lg: '0', sm: '0' }}>
                        <Heading
                            className="introHeading"
                            w="full"
                            fontSize={{ base: '28px', lg: '40px' }}
                            display="flex"
                            ml={{ sm: '20px' }}
                        >
                            <Skeleton isLoaded={!loading}>
                                Welcome {userData?.me?.first_name ?? 'friend!'} 👋
                            </Skeleton>
                        </Heading>
                        <Box>
                            {isMobile ? <Checklist /> : ''}

                            {/* {userData?.me?.profile?.id &&
                            Boolean(userData?.me.profile?.elevator_pitch_url) === false ? (
                                <ElevatorPitch
                                    name={userData?.me?.first_name ?? ''}
                                    profileId={userData?.me?.profile?.id ?? ''}
                                    hasVideo={Boolean(userData?.me?.profile?.elevator_pitch_url)}
                                />
                            ) : (
                                ''
                            )} */}

                            <ProfileLive slug={userData?.me?.profile?.slug || ''} />

                            {isMobile ? <DiscordInvite /> : ''}

                            {shouldShowWelcomeMsg && (
                                <WelcomeCard
                                    setShouldShowWelcomeMsg={setShouldShowWelcomeMsg}
                                    toggleWelcomeMutation={toggleWelcomeMsgMutation}
                                />
                            )}

                            {isMobile ? <HiringGuide /> : ''}
                            {isMobile && !userData?.me ? <CareerAssessment /> : ''}
                        </Box>
                    </Flex>
                    <Box>
                        {!isMobile ? <Checklist /> : ''}
                        {!isMobile ? <DiscordInvite /> : ''}
                        {!isMobile ? <HiringGuide /> : ''}
                        {!isMobile && !userData?.me ? <CareerAssessment /> : ''}
                    </Box>
                </Grid>
            </Container>
            <Footer />
        </>
    );
}

export default Dashboard;
